import { render, staticRenderFns } from "./export-direct-debit-file-modal.vue?vue&type=template&id=2cbba2e2&scoped=true&"
import script from "./export-direct-debit-file-modal.vue?vue&type=script&lang=ts&"
export * from "./export-direct-debit-file-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbba2e2",
  null
  
)

export default component.exports